import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Axios from "axios";
import Swal from "sweetalert2";  // Make sure you import Swal

const Verifyemail = () => {
  const search = useLocation().search;
  const token = new URLSearchParams(search).get("id");
  const navigate = useNavigate();

  const APICall = () => {
    console.log("12")
    const filterData = { guid: token };   // fixed field name: guid not token

    Axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/verifyemail`, filterData)

      .then((result) => {
        const message = result.data.message;

        if (message === 'Email verified successfully') {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Email verified successfully!',
            showConfirmButton: false,
            timer: 2000
          });
          setTimeout(() => {
            navigate("/Login");  // navigate after success
          }, 2000);
        } else if (result.data.error === 'Invalid verification link or already verified') {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Invalid verification link or already verified!',
            showConfirmButton: false,
            timer: 3000
          });
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Something went wrong!',
            showConfirmButton: false,
            timer: 3000
          });
        }
      })
      .catch((error) => {
        console.log("Error verifying email:", error);
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Server error, please try again later!',
          showConfirmButton: false,
          timer: 3000
        });
      });
  };

  useEffect(() => {
      APICall();
  }, []);

  return (
    <div className="container" style={{ height: 700 }}>
      <div className="row">
        <div className="col-12">
          {/* You can show a loader/spinner here if you want */}
        </div>
      </div>
    </div>
  );
};

export default Verifyemail;
